import type {
    AuctionHouse,
    AuctionHouseWithStats,
    CreateAuctionHouseData,
    UpdateAuctionHouseData
} from '@/types/auction-house';
import { apiService } from './apiService';

export const auctionHouseApi = {
    async getUserAuctionHouses(): Promise<AuctionHouse[]> {
        return apiService.get<AuctionHouse[]>('/auction-house');
    },

    async getAuctionHouse(slug: string): Promise<AuctionHouse> {
        return apiService.get<AuctionHouse>(`/auction-house/${ slug }`);
    },

    async getPublicAuctionHouse(slug: string): Promise<AuctionHouse> {
        return apiService.get<AuctionHouse>(`/auction-house/public/${ slug }`);
    },

    async getAllWithStatistics(): Promise<AuctionHouseWithStats[]> {
        return apiService.get('/auction-house/statistics/all');
    },

    async create(data: CreateAuctionHouseData): Promise<AuctionHouseWithStats> {
        const formData = new FormData();
        formData.append('slug', data.slug);
        formData.append('content', JSON.stringify(data.content));
        if (data.status) {
            formData.append('status', data.status);
        }
        if (data.logo) {
            formData.append('logo', data.logo);
        }
        if (data.icon) {
            formData.append('icon', data.icon);
        }
        if (data.phone) {
            formData.append('phone', data.phone);
        }
        if (data.email) {
            formData.append('email', data.email);
        }
        if (data.whatsapp) {
            formData.append('whatsapp', data.whatsapp);
        }
        if (data.social) {
            formData.append('social', JSON.stringify(data.social));
        }

        return apiService.post('/auction-house', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    async update(slug: string, data: UpdateAuctionHouseData): Promise<AuctionHouseWithStats> {
        const formData = new FormData();
        if (data.content) {
            formData.append('content', JSON.stringify(data.content));
        }
        if (data.status) {
            formData.append('status', data.status);
        }
        if (data.logo) {
            formData.append('logo', data.logo);
        }
        if (data.icon) {
            formData.append('icon', data.icon);
        }
        if (data.phone !== undefined) {
            formData.append('phone', data.phone);
        }
        if (data.email !== undefined) {
            formData.append('email', data.email);
        }
        if (data.whatsapp !== undefined) {
            formData.append('whatsapp', data.whatsapp);
        }
        if (data.social) {
            formData.append('social', JSON.stringify(data.social));
        }

        return apiService.patch(`/auction-house/${ slug }`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    async delete(slug: string): Promise<void> {
        return apiService.delete(`/auction-house/${ slug }`);
    },
};
